import React from 'react'
import { classNames } from 'helpers'

interface IconButtonProps {
  type?: 'button' | 'submit' | 'reset'
  icon: any
  rounded?: boolean
  framed?: boolean
  size?: 'small' | 'medium' | 'large'
  backgroundColor?: 'indigo' | 'lightblue' | 'white'
  onClick?: any
  className?: string
}

const styles = {
  base:
    'inline-flex items-center justify-center focus:outline-none',
  size: {
    small: 'p-1.5',
    medium: 'p-2',
    large: 'p-3',
  },
  framed:
    'shadow-sm text-white hover:shadow-4xl active:shadow-none focus:ring-2 focus:ring-indigo-2',
  backgroundColor: {
    indigo: 'bg-indigo-2 hover:bg-indigo-1',
    lightblue: 'bg-blue-0',
    white: 'bg-white',
  },
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  type = 'button',
  size = 'medium',
  rounded = 'true',
  framed,
  backgroundColor = 'lightblue',
  onClick,
  className,
  ...args
}) => {
  const Icon = icon

  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames(
        styles.base,
        rounded ? 'rounded' : 'rounded-none',
        styles.size[size],
        styles.backgroundColor[backgroundColor],
        framed && styles.framed,
        className
      )}
      {...args}
    >
      <Icon className="w-5 h-5" aria-hidden="true" />
    </button>
  )
}

export default IconButton
